export default __webpack_public_path__ + "static/islasridge-c8855bd9f692afa4f3bc7f77cad56dee.png";